import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetCurrentTenantQuery } from '../api/tenant';
import { RootState } from '../Store/store';

/**
 * Custom hook to fetch and manage tenant data
 * This hook will automatically fetch tenant data when the user is authenticated
 */
export const useTenantData = () => {
  // Get authentication state from Redux
  const authState = useSelector((state: RootState) => state.auth);
  const isAuthenticated = authState.isAuthenticated;

  const { 
    data: tenantData, 
    isLoading, 
    isError, 
    error,
    refetch 
  } = useGetCurrentTenantQuery(undefined, {
    // Skip the query if we're not authenticated
    skip: !isAuthenticated,
    // Refetch on window focus to keep data fresh
    refetchOnFocus: true,
    // Refetch on reconnect
    refetchOnReconnect: true,
  });

  useEffect(() => {
    if (tenantData) {
      console.log('✅ Tenant data fetched successfully:', tenantData);
      
      // Log specific fields if they exist
      if (tenantData.status) {
        console.log('✅ Tenant Status:', tenantData.status);
      }
      if (tenantData.subscription) {
        console.log('✅ Tenant Subscription:', tenantData.subscription);
      }
    }
  }, [tenantData]);

  useEffect(() => {
    if (isError) {
      console.error('❌ Error fetching tenant data:', error);
    }
  }, [isError, error]);

  // Log when authentication state changes
  useEffect(() => {
    if (isAuthenticated) {
      console.log('🔐 User authenticated, tenant API will be called');
    } else {
      console.log('🔓 User not authenticated, tenant API skipped');
    }
  }, [isAuthenticated]);

  return {
    tenantData,
    isLoading,
    isError,
    error,
    refetch,
    isAuthenticated,
  };
}; 